export const serviceLinks = [
  { title: "Septic System Installation in Thunder Bay", slug: "septic-system-installation-thunder-bay" },
  { title: "Septic Field Installation / Replacement Thunder Bay", slug: "septic-field-installation-replacement-thunder-bay" },
  { title: "Septic Tank Install & Replacement", slug: "septic-tank-installation-thunder-bay" },
  { title: "Roth MultiTank – Plastic Septic & Water Tanks", slug: "roth-multitank-supplier-thunder-bay" },
  { title: "Septic Repair Near Me", slug: "septic-repair-near-me" }
];

export const primaryLinks = [
  { title: "Home", path: "/" },
  { title: "Service Areas", path: "/service-areas" },
  { title: "Information Centre", path: "/information-centre" },
  { title: "Cost Calculator", path: "/septic-calculator" }
];

export const moreLinks = [
  { title: "About", path: "/about" },
  { title: "Reviews", path: "/testimonials" },
  { title: "FAQ", path: "/faq" },
  { title: "Divisions", path: "/divisions" }
];

export const linkId = (path) => path === "/" ? "home" : path.slice(1).replaceAll("/", "-");